import { Pipe, PipeTransform, OnDestroy } from '@angular/core';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'taskListPresentDate',
  pure: false
})
export class TaskListPresentDatePipe implements PipeTransform, OnDestroy {
  private localeChangeListener: any;

  constructor(private translateService: TranslateService) {
    // Listen for locale changes
    this.localeChangeListener = () => {
      // Force Angular to re-evaluate the pipe by triggering change detection
      this.translateService.get('shared.taskList.dates.today').subscribe(() => {});
    };
    document.addEventListener('localeChange', this.localeChangeListener);
  }

  ngOnDestroy(): void {
    // Clean up the event listener when the pipe is destroyed
    document.removeEventListener('localeChange', this.localeChangeListener);
  }

  transform(d: string | Date, args?: any): string {
    const today = new Date();
    const day = new Date(d);

    if (day.getDate() === today.getDate() && day.getFullYear() === today.getFullYear()) {
      return this.translateService.instant('shared.taskList.dates.today');
    }

    if (day.getDate() + 1 === today.getDate() && day.getFullYear() === today.getFullYear()) {
      return this.translateService.instant('shared.taskList.dates.yesterdayOverdue');
    }

    if (day.getDate() - 1 === today.getDate() && day.getFullYear() === today.getFullYear()) {
      return this.translateService.instant('shared.taskList.dates.tomorrow');
    }

    return moment(new Date(day)).format('DD MMM YYYY');
  }
}
